import { tracker } from "~/common/tracker";

type SaReportEventParams = Record<string, unknown>;

// 增长中台神策上报事件名映射
export const SPEventMap: Record<string, (params: SaReportEventParams) => void> = {
  click: (params: SaReportEventParams): void => {
    tracker.activityClick({
      sa: {
        ...params,
      },
    });
  },
  expose: (params: SaReportEventParams): void => {
    tracker.expose({
      sa: {
        ...params,
      },
    });
  },
  input: (params: SaReportEventParams): void => {
    tracker.activityInput({
      sa: {
        ...params,
      },
    });
  },
};
